/**
 * @generated SignedSource<<12b4cc7ccb74bd65ac8c2327130b645b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type Type = "PRAISE" | "REQUESTED" | "UNSOLICITED";
export type CreateFeedbackButtonCreateDraftMutation$variables = {
  type: Type;
};
export type CreateFeedbackButtonCreateDraftMutation$data = {
  readonly createDraftFeedback: {
    readonly feedback: {
      readonly id: string;
    };
  } | null;
};
export type CreateFeedbackButtonCreateDraftMutation = {
  response: CreateFeedbackButtonCreateDraftMutation$data;
  variables: CreateFeedbackButtonCreateDraftMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "type"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "type",
        "variableName": "type"
      }
    ],
    "concreteType": "CreateDraftFeedback",
    "kind": "LinkedField",
    "name": "createDraftFeedback",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "FeedbackNode",
        "kind": "LinkedField",
        "name": "feedback",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateFeedbackButtonCreateDraftMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateFeedbackButtonCreateDraftMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0f350ecab6c1b6b874ff9c7d65a29ab7",
    "id": null,
    "metadata": {},
    "name": "CreateFeedbackButtonCreateDraftMutation",
    "operationKind": "mutation",
    "text": "mutation CreateFeedbackButtonCreateDraftMutation(\n  $type: Type!\n) {\n  createDraftFeedback(type: $type) {\n    feedback {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "443cb5d6e219c698a80da5009c2ff9d6";

export default node;
